import React from 'react'
import { List, Button, Card, Label } from 'semantic-ui-react'
import _ from 'lodash'
import moment from 'moment'

const styles = {
  listContentWrapper: {
    padding: '3px 0px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
}

const Row = ({ field, startDate, endDate }) => {
  return (
    <List.Item>
      <List.Content style={styles.listContentWrapper}>
        <div style={{ display: 'flex', flex: 1 }}>
          {field}
        </div>

        <div style={{ display: 'flex' }}>
          <Label size="small" color="green">
            {startDate}
          </Label>
          <Label size="small" color="grey">
            {endDate}
          </Label>
        </div>
      </List.Content>
    </List.Item>
  )
}

const convertTime = timestamp => {
  return moment(Number(timestamp)).format('DD-MMM')
}

const UnavailableItemCard = ({ onEdit, onDelete, items, data, branchName }) => {
  return (
    <Card>
      <Card.Content>
        <Card.Header>{branchName}</Card.Header>
        <Card.Meta>Items ({_.size(data)})</Card.Meta>
        <Card.Description style={{ paddingRight: 10, minHeight: 200, maxHeight: 250, overflow: 'auto'}}>
          <List divided verticalAlign='middle' style={{ marginTop: 10 }}>
            {
              _.map(data, item => {
                const { item_id: id, started_at: start, ended_at: end } = item
                const itemName = _.get(items, [id, 'name'], 'Item was deleted')

                return (
                  <Row field={itemName} startDate={convertTime(start)} endDate={convertTime(end)} key={id} />
                )
              })
            }
          </List>
        </Card.Description>
      </Card.Content>
      <Card.Content extra textAlign='right' >
        <Button color='black' size="tiny" onClick={onEdit}>Edit</Button>
        <Button color='red' size="tiny" onClick={onDelete}>Delete</Button>
      </Card.Content>
    </Card>
  )
}

export default UnavailableItemCard


// WEBPACK FOOTER //
// ./src/components/restaurants/views/unavailableItemCard.js